import { render, staticRenderFns } from "./GameOverlayView.vue?vue&type=template&id=1f20e5de&"
import script from "./GameOverlayView.vue?vue&type=script&lang=js&"
export * from "./GameOverlayView.vue?vue&type=script&lang=js&"
import style0 from "./GameOverlayView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GameOverlayView.vue"
export default component.exports